import type { cast as castNs } from 'chromecast-caf-receiver';
import type { LiveSeekableRange, MediaStatus } from 'chromecast-caf-receiver/cast.framework.messages';

import { liveSeekableRangePatch } from './liveSeekableRangePatch';

declare const cast: typeof castNs;

export const applyLiveSeekableRangePatch = (mediaStatus: MediaStatus): MediaStatus => {
    if (!liveSeekableRangePatch.isEnabled) {
        return mediaStatus;
    }

    const { liveSeekableRange } = mediaStatus;
    if (!liveSeekableRange) {
        return mediaStatus;
    }

    // The old receiver used to report liveSeekableRange.start = 0 for all live streams,
    // and never updated this as the stream progressed forward. This caused the DVR window to
    // be off-sync on the sender / receiver from each other, but couldn't be fixed due to information
    // hidden by the dvrMiddleware.
    // The new receiver operates without DVR middleware, so this is not an issue anymore
    // but due to some incompatibilities we need to reproduce the same behavior for mobile senders
    // while issues are being resolved there.

    // `start` and `end` are not exposed in @types/chromecast-caf-receiver
    type LiveSeekableRangePatched = LiveSeekableRange & {
        end?: number;
        start?: number;
    };

    const { end, isLiveDone, isMovingWindow, start } = liveSeekableRange as LiveSeekableRangePatched;

    if (start == null || end == null) {
        return mediaStatus;
    }

    mediaStatus.currentTime -= start;
    mediaStatus.liveSeekableRange = new cast.framework.messages.LiveSeekableRange(0, end - start, isMovingWindow, isLiveDone);

    return mediaStatus;
};
